var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7999 20.0118C25.7249 19.8024 25.6725 19.5823 25.6457 19.3543C24.1558 19.179 23 17.912 23 16.375C23 15.7226 23.2083 15.1188 23.5619 14.6265C23.2354 14.625 22.8827 14.625 22.5 14.625C20.0538 14.625 18.8307 14.625 17.8659 15.0246C16.5795 15.5575 15.5575 16.5795 15.0246 17.8659C14.625 18.8307 14.625 20.0538 14.625 22.5V25.125C14.625 27.5999 14.625 28.8373 15.3938 29.6062C16.1627 30.375 17.4001 30.375 19.875 30.375H22.5C24.9462 30.375 26.1693 30.375 27.1341 29.9754C28.4205 29.4425 29.4425 28.4205 29.9754 27.1341C30.375 26.1693 30.375 24.9462 30.375 22.5C30.375 22.1173 30.375 21.7646 30.3735 21.4381C29.8812 21.7917 29.2774 22 28.625 22C27.5784 22 26.657 21.4641 26.1203 20.6517C26.1234 20.684 26.125 20.7167 26.125 20.7497C26.125 21.302 25.6773 21.7497 25.125 21.7497H19.875C19.3227 21.7497 18.875 21.302 18.875 20.7497C18.875 20.1974 19.3227 19.7497 19.875 19.7497H25.125C25.3851 19.7497 25.622 19.849 25.7999 20.0118ZM19.875 23.2497C19.3227 23.2497 18.875 23.6974 18.875 24.2497C18.875 24.802 19.3227 25.2497 19.875 25.2497H22.5C23.0523 25.2497 23.5 24.802 23.5 24.2497C23.5 23.6974 23.0523 23.2497 22.5 23.2497H19.875Z",
    fill: "#760000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 19L28.625 13.75M26 16.375H31.25",
    stroke: "#760000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.87f270351af4924b506c42118a77d811.svg";
export { ForwardRef as ReactComponent };